import React from 'react'
import Breadcrumb from '../../../shared/components/atoms/breadcrumb/breadcrumb';
import Img from 'gatsby-image';
import './content.scss'
import { useStaticQuery, graphql } from 'gatsby';
import SignsItem from '../../atoms/signs-item/signs-item';

const Content = props =>{
    // var news_info=props.dataProp
    const resultQuery = useStaticQuery(
        graphql`
        query GET_HOROSCOPE_CONTENT_PPL{
            allContentfulNolHomeTercerNivel(filter: {titulo: {eq: "Horóscopo"}}) {
                nodes {
                    node_locale
                    titulo
                    slug
                    banner {
                        bannerSecciones {
                        file {
                            url
                        }
                        fluid(maxWidth: 1920, quality: 100) {
                            ...GatsbyContentfulFluid_withWebp_noBase64
                        }
                        fixed {
                                    base64
                                }
                        description
                        }
                        tituloBanner
                    }
                    signosDeLosHoroscopos {
                        titulo
                        iconoDelSigno
                        slug
                        fechaDelSigno
                        descripcionDelSigno {
                            descripcionDelSigno
                        }
                    }
                    subtituloGeneral {
                        subtituloGeneral
                      }
                    
                }
            }
        }
        
    `
    )
    var infoHoroscope = resultQuery.allContentfulNolHomeTercerNivel.nodes.filter(e => e.node_locale === process.env.LOCALE)[0]
    const fluidImage = infoHoroscope.banner.bannerSecciones[0].fluid

    return (
        <div className="f-Content">
        <div className="f-header-horoscope">
            <div className="f-header-horoscope-banner">
                <Img 
                    loading='eager'
                    alt={infoHoroscope.banner.bannerSecciones[0].description}
                    fluid={fluidImage}
                />
            </div>
            <div className="f-header-horoscope-title">
                <h1><span>{infoHoroscope.titulo}</span></h1>
            </div>
        </div>
        <div className="f-breadcrum-position">
            <Breadcrumb mobile={props.mobile}/>

        </div>
        <div className="f-Content-home">
            <p className="f-Content-home-copy">{infoHoroscope.subtituloGeneral.subtituloGeneral}</p>
            <div className="f-Content-home-list-signs">
                {infoHoroscope.signosDeLosHoroscopos.map((sing, index) => {
                    return (
                        <SignsItem key={index} infoSing={sing} />
                    )
                })}
            </div>
        </div>
        </div>
    )
}
export default Content;
